export default __webpack_public_path__ + "static/media/02_south_flower_a2.467e9d02.mp4";